var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "editIconActive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    d: "M.173,11.033,0,2.507a1,1,0,0,1,.278-.713L2,0,3.726,1.8A1,1,0,0,1,4,2.5L3.98,11.015a1,1,0,0,1-1,1H1.174A1,1,0,0,1,.173,11.033Z",
    transform: "translate(6.836 12.662) rotate(-135)",
    fill: "#2e71fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-57",
    d: "M9.275,2a.667.667,0,0,1,0,1.335H4.67A1.335,1.335,0,0,0,3.335,4.67v8.009A1.335,1.335,0,0,0,4.67,14.014h8.009a1.335,1.335,0,0,0,1.335-1.335V9.342a.667.667,0,1,1,1.335,0v3.337a2.67,2.67,0,0,1-2.67,2.67H4.67A2.67,2.67,0,0,1,2,12.679V4.67A2.67,2.67,0,0,1,4.67,2Z",
    transform: "translate(-0.665 -0.665)",
    fill: "#2e71fc",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconBlue);
export default __webpack_public_path__ + "static/media/editIconBlue.481c2cba94c61cb05394ebf27b0c00a0.svg";
export { ForwardRef as ReactComponent };